<template>
<div class="Main">

  <SlideMenu>
    <router-link to="/dashboard">Homepage</router-link>
    <router-link to="/main">Main Menu</router-link>
    <span v-if="PageData.download"><a :href="PageData.download">Download</a></span>
    <span v-if="PageData.video"><a :href="PageData.video">Youtube</a></span>
    <a class="cpointer" @click="$router.go(-1)">Back</a>
  </SlideMenu>

  <div class="container">
    <div class="row">
      <div class="col s12 s12 logo-box">
        <h1 class="titleh1">{{PageData.name}}</h1>
        <div class="breadcrumb-nav">
          You are here : &nbsp;&nbsp;&nbsp;
          <span v-for="menulink in PageData.menu">
            <router-link :to="menulink.link">{{menulink.name}}</router-link> &nbsp;»&nbsp;
          </span>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="col s12">
        <div class="row document-view">
          <div v-if="PageData.source == 'poster'" class="center-align">
            <div v-if="PageData.doc_zoom == 'Y'">
              <p class="center-align">Use your mouse scroll to zoom in/out.</p>
              <v-zoomer style="width: 100%; border: solid 1px silver;">
                <img :alt="PageData.name" class="responsive-img" :src="PageData.prefix" style="object-fit: contain; width: 100%; height: 100%;">
              </v-zoomer>
            </div>
            <div v-else>
              <img :alt="PageData.name" class="responsive-img" :src="PageData.prefix">
            </div>
          </div>
          <div v-if="PageData.source == 'slide'" class="center-align">
            <hooper>
              <Slide v-for="n in PageData.totalpage">
                <v-lazy-image class="responsive-img" :src="PageData.prefix + checkpage(n)" :alt="PageData.name" />
              </Slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons" mode="fraction"></hooper-pagination>
            </hooper>
          </div>
          <div v-if="PageData.source == 'pdf'" class="center-align">
            <hooper>
              <Slide v-for="n in PageData.totalpage">
                <v-lazy-image class="responsive-img" :src="PageData.prefix + checkpage(n)" :alt="PageData.name" />
              </Slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons" mode="fraction"></hooper-pagination>
            </hooper>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <FooterText />
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VLazyImagePlugin from 'v-lazy-image'
import {
  Slide as SlideMenu
} from 'vue-burger-menu'
import FooterText from './Footertext'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: 'Main',
  data() {
    return {
      usercookie: $cookies.get('arch-asic'),
      PageData: []
    }
  },
  components: {
    SlideMenu,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    FooterText
  },
  methods: {
    fetchDataDocument: function() {
      axios({
        method: 'post',
        url: 'https://www.archipelagointernational.com/api/asic/query',
        data: {
          query: `
            query {
                document(id:${this.$route.params.id}) {
                  name,
                  slug,
                  totalpage,
                  prefix,
                  source,
                  download,
                  video,
                  zoom,
                  doc_zoom,
                  menu {
                    name,
                    link
                  }
                }
            }
          `
        },
        headers: {
          'Authorization': 'Bearer ' + this.usercookie,
          'Content-Type': 'application/json'
        }
      }).then(response => (this.PageData = response.data.data.document));
    },
    checkpage: function(value) {
      var page
      page = value + '.jpg'
      return page
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loginstatus: function(e) {
      if (e != 'Success') {
        //console.log(e);
        router.push({
          name: 'Login'
        })
      } else {
        //this.isLogin = true
        //console.log(e);
      }
    }
  },
  created() {
    this.fetchDataDocument();
  },
  mounted() {
    this.toggleBodyClass('addClass', 'back-directory');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'back-directory');
  }
}
</script>

<style>
.back-directory {
  background: url(https://cdn0.archipelagointernational.com/StaffCentre/assets/images/background-v4.jpg) center center no-repeat fixed #00215B;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: #fff;
}

.document-view {
  margin-top: 20px;
}

.hooper {
  min-height: 300px;
  height: auto !important;
}

.hooper-pagination {
  color: #000 !important;
}

.hooper-next,
.hooper-prev {
  background-color: #ccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Document.vue